import React from 'react';
import { gql, useQuery } from '@apollo/client';
import {
  HeadingBanner, IconBlock, Icon,
} from 'anf-core-react';
import { ERROR_MESSAGE, LOADING_MESSAGE } from '../../components/Messages/Messages';
// TODO: (DDS-128)Remove this and the LinkListArrow Component and use the one from the DS
import LinkListArrow from '../../components/LinkListArrow/LinkListArrow';

const query = gql`
  {
    textFor {
      pageTitle: pair(pairKey: "allStores") {...textPair}
      storeLocator: pair(pairKey: "storeLocator") {...textPair}
    }
    storesByRegion {
      region {...textPair}
      stores {
        storeRef
        brandLogo
        brandText {...textPair}
        city
        name
        url
      }
    }
    config {
      storeLocatorUrl: string(name: "storeLocatorUrl")
    }
  }
  fragment textPair on TextPair {
    key
    value
  }
`;

export default function AllStoresPage() {
  const { loading, error, data } = useQuery(query);
  if (loading) return LOADING_MESSAGE;
  if (error) return ERROR_MESSAGE;

  const buildLinks = (storeList, region) => storeList.map((store, index) => (
    {
      href: store.url,
      key: `${region}-store-${index}`,
      children: (
        <IconBlock centerVertically icon={(<Icon icon={store.brandLogo} size="s" />)}>
          <span
            className="screen-reader-text"
            data-text-key={store.brandText?.key}
          >
            {store.brandText.value}
          </span>
          <span>
            <span className="all-stores__city">{store.city}</span>
            <span>{`, ${store.name}`}</span>
          </span>
        </IconBlock>),
    }
  ));

  const renderRegions = (regionList) => regionList.map((region) => (
    <li className="all-stores__region" key={region.region.value}>
      <div className="all-stores__region-inner-wrapper">
        <HeadingBanner>
          <h2 className="h2" data-text-key={region.region.key}>{region.region.value}</h2>
        </HeadingBanner>
        <div className="all-stores__store-list">
          <LinkListArrow links={buildLinks(region.stores, region)} />
        </div>
      </div>
    </li>
  ));

  return (
    <main className="all-stores">
      <div style={{ marginBottom: '30px' }}>
        <HeadingBanner>
          <div className="all-stores__header">
            <div>
              <h1 className="h1" data-text-key={data.textFor.pageTitle.key}>
                {data.textFor.pageTitle.value}
              </h1>
            </div>
            <div>
              <a
                href={data.config.storeLocatorUrl}
                data-text-key={data.textFor.storeLocator.key}
              >
                {data.textFor.storeLocator.value}
              </a>
            </div>
          </div>
        </HeadingBanner>
      </div>
      <div>
        <ul className="all-stores__region-list">
          {renderRegions(data.storesByRegion)}
        </ul>
      </div>
    </main>
  );
}
